module.exports = __webpack_public_path__ + "static/img/toujiao2.c95edc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toujiao2.jpg
// module id = vcq6
// module chunks = 1